exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".page-content{font-size:16px}", "", {"version":3,"sources":["/home/webuser/yokohama/releases/50/spa/src/pages/policyPage/PolicyPage.vue"],"names":[],"mappings":"AAkBA,cACE,cAAA,CAAA","file":"PolicyPage.vue?vue&type=style&index=1&lang=scss&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.page-content {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);

// exports
